import { Box, CircularProgress } from "@mui/material";
import { PureLightThemeCaaS } from "src/theme/schemes/PureLightTheme";

function SuspenseLoader() {
  return (
    <Box
      sx={{
        position: "fixed",
        left: 0,
        top: 0,
        width: "100%",
        height: "100%",
        bgcolor: "#000000",
      }}
      display="flex"
      alignItems="center"
      justifyContent="center"
    >
      <CircularProgress size={64} disableShrink thickness={3} sx={{ color: `${PureLightThemeCaaS.colors.alpha.orange[100]}` }} />
    </Box>
  );
}

export default SuspenseLoader;
